// src/data/portfolio.js
// Itens do portfólio. Para adicionar um imóvel novo, inclua um objeto aqui —
// não é preciso mexer em componente.
//
// Tipos aceitos em `tipo`: "Apartamento" | "Casa" | "Lançamento" | "Terreno e rural"
// `midia.kind`: "youtube" (usa `id` do vídeo) | "video" (arquivo local em /public) | "imagem"
export const PORTFOLIO = [
  {
    id: "obra-aereas-01",
    tipo: "Lançamento",
    tag: "AR · 4K",
    titulo: "Empreendimento em construção · vista aérea",
    local: "Recife/PE",
    midia: { kind: "video", src: "/videos/drone.mp4" },
  },
  // Próximos itens: vídeos do YouTube (não listados) —
  // { id: "...", tipo: "Apartamento", tag: "TOUR · 90s", titulo: "...", local: "...", midia: { kind: "youtube", id: "ID_DO_VIDEO" } },
];

// Ordem fixa dos filtros do portfólio
export const TIPOS = ["Apartamento", "Casa", "Lançamento", "Terreno e rural"];
